<section>
    <mat-card-content>
        <div>
            <div>
                <app-file-manager-grid *ngIf="currentDocumentTreeNode" 
                [folderTreeNode]="currentDocumentTreeNode"
                [canNavigatePrev]="canNavigatePrev"
                [path]="currentPath"
                [noContentMessage]="'No hay documentos subidos'"
                (navigateUp)="navigateUpFolder()"
                (navigateDown)="navigateToFolder($event)"
                (removeFile)="confirmDeleteCompanyDocument($event)"
                (uploadFile)="uploadCompanyDocument()"
                (previewFile)="previewDocument($event)"
                (cancelSignFile)="cancelSignDocument($event)"
                (newDocument)="generateNewDocument()">
                </app-file-manager-grid>
            </div>        
        </div>
    </mat-card-content>
</section>